// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textCenter = "DescriptionList__textCenter__wuZQl";
export const descriptionList = "DescriptionList__descriptionList__XimaK font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const fieldLabel = "DescriptionList__fieldLabel__Fr1ni";
export const fieldValue = "DescriptionList__fieldValue__ocVxe";
export const labelText = "DescriptionList__labelText__yfCx4";
export const dimmed = "DescriptionList__dimmed__4Wuh4";
export const tooltipIconWrapper = "DescriptionList__tooltipIconWrapper__r2onl";